@if (categoriesNew$ |async; as categoriesNew) {
<section
  class="megamenu"
  #megamenu
  (mouseenter)="!isMobile && checkIsMegaMenuOnHover()"
  (mouseleave)="!isMobile && checkIsMegaMenuOnHover()"
>
  <div class="container">
    <div class="containerColumns" #megamenuColumns>
      <div class="categories" #categories>
        <div class="contentCategoriesItems">
          <div class="titleMegaMenu">
            @if (isMobile) {
            <button class="btnBackMegamenu" (click)="hideCategories()">
              <div class="contentImage">
                <img src="/general/chevron-left.svg" alt="left arrow" width="24" height="24" />
              </div>
            </button>
            <span>EQUIPOS NUEVOS</span>
            }@else { EQUIPOS NUEVOS }
          </div>
          @for (category of categoriesNew; track $index) {
          <div
            class="category"
            [id]="'category-' + category.slug"
            (mouseenter)="!isMobile && showSubcategories(category.slug)"
            (click)="isMobile && showSubcategories(category.slug)"
          >
            {{ category.name }}
          </div>
          }
          <a
            routerLink="/productos"
            class="category btnMegaMenu"
            (click)="isMobile ? closeAll() : closeMegaMenu()"
            >Ver todos los equipos</a
          >
        </div>
      </div>
      <div class="subcategories" #subcategories>
        @for (category of categoriesNew; track $index) {
        <div class="contentSubcategoriesColumn" [id]="category.slug">
          <div class="titleCategory">
            @if (isMobile) {
            <button class="btnBackMegamenu" (click)="hideSubcategories()">
              <div class="contentImage">
                <img src="/general/chevron-left.svg" alt="left arrow" width="24" height="24" />
              </div>
            </button>
            <span>{{ category.name | uppercase }}</span>
            }@else { {{ category.name | uppercase }} }
          </div>
          <div
            class="contentSubcategoriesItems"
            [ngClass]="{
              col2: category.subcategories.length > categoriesNew.length + 1 && !isMobile
            }"
          >
            @for (subcategory of category.subcategories; track $index) {
            <a
              [routerLink]="'/productos/' + category.slug + '/' + subcategory.slug"
              class="subcategory"
              (click)="isMobile ? closeAll() : closeMegaMenu()"
              >{{ subcategory.name }}</a
            >
            }
            <a
              [routerLink]="'/productos/' + category.slug"
              class="subcategory btnMegaMenu"
              (click)="isMobile ? closeAll() : closeMegaMenu()"
              >Ver {{ category.name | lowercase }}</a
            >
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</section>

<div id="gradient"></div>
}
